import React, { useContext } from "react";
import { compose } from "redux";
import { useHistory } from "react-router-dom";
import {
  Container,
  Text,
  InputContainer,
  Input,
  SocialShares,
  withStyles,
  BreakpointContext,
  referralLink,
  ReferralLinkButton,
} from "components/common";

import { Unity } from "components/common/Svg";
import { useSelector } from "react-redux";

const ambassadorReferralText = `and for
every person you invite that is approved, we will reward you
with an extra 1% cash back.`;

const Refer = ({ user, compact = false }) => {
  const { push } = useHistory();
  const roles = useSelector((state) => state.user.roles);
  const { isBelow } = useContext(BreakpointContext);

  if (compact) {
    return (
      <Container className="w-full flex-1">
        <div className="flex h-full flex-row text-left">
          <div className="flex justify-center mb-2 pr-4">
            <Unity className="w-16" />
          </div>
          <div className="flex items-center justify-start">
            {roles.ambassador ? (
              <Text className="text-green-primary text-3xl font-bold text-center md:text-left font-title mr-8 leading-tight">
                Boost your cash back <br />
                <span className="text-black-primary">up to 20%</span>
              </Text>
            ) : (
              <Text className="text-green-primary text-2xl font-bold text-left leading-tight mr-12">
                Refer your friends
              </Text>
            )}
            <Text className="text-gray-primary text-2xl">Share on:</Text>
            <SocialShares size={36} url={referralLink(user)} />
            <ReferralLinkButton
              user={user}
              className="btn btn-green w-auto ml-6"
            >
              Copy Link
            </ReferralLinkButton>
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Container
      className="w-full flex-1"
      paddingHorizontal={28}
      paddingVertical={28}
    >
      <div className="flex h-full flex-col md:flex-row md:text-left">
        <div className="flex w-full justify-center mb-2 md:w-auto md:mr-8">
          <Unity
            className="w-full"
            style={{
              maxWidth: isBelow("md") ? "120px" : null,
              width: !isBelow("md") ? "100px" : null,
            }}
          />
        </div>
        <div className="md:flex-1 md:text-left md:pr-4">
          {roles.ambassador ? (
            <>
              <Text className="text-green-primary text-3xl font-bold text-center md:text-left font-title mb-2 leading-tight">
                Boost your cash back{" "}
                <span className="text-black-primary">up to 20%</span>
              </Text>
              <Text className="text-center md:text-left">
                <span className="font-bold">Share your referral link </span>
                {ambassadorReferralText}{" "}
                <span
                  onClick={() => {
                    push("/referrals");
                  }}
                  className="underline cursor-pointer"
                >
                  Click here
                </span>{" "}
                to learn more
              </Text>
            </>
          ) : (
            <>
              <Text className="text-green-primary text-3xl font-bold text-center md:text-left font-title mb-2 leading-tight">
                Refer your friends
              </Text>
              <Text className="text-center md:text-left">
                <span className="font-bold">Share your referral link!</span>
              </Text>
            </>
          )}

          <div className="mt-2">
            <div className="md:hidden">
              <InputContainer backgroundColor="#F8F9F9">
                <Input
                  value={referralLink(user)}
                  className="referralLinkInput text-gray-600"
                />
              </InputContainer>
              <ReferralLinkButton
                user={user}
                className="btn btn-green w-full mt-3"
              >
                Copy Link
              </ReferralLinkButton>
            </div>
            <div className="hidden md:flex">
              <InputContainer
                backgroundColor="#F8F9F9"
                className="rounded-r-none flex-1"
              >
                <Input
                  value={referralLink(user)}
                  className="referralLinkInput text-gray-600"
                />
              </InputContainer>
              <ReferralLinkButton
                user={user}
                className="btn btn-green rounded-l-none w-auto"
              >
                Copy Link
              </ReferralLinkButton>
            </div>

            <div className="flex items-center mt-6 justify-center md:justify-start">
              <Text className="text-gray-primary">Share on:</Text>
              <SocialShares size={24} url={referralLink(user)} />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default compose(withStyles)(Refer);
